// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rFRK","question":"styles_question__3TIog","description":"styles_description__35rdL"};